module.exports = __webpack_public_path__ + "static/media/playButton.eebb1d12.svg";